import * as THREE from '../three'

import { System } from './System'

export const Hands = {
  LEFT: 'left',
  RIGHT: 'right',
}

export class InputSystem extends System {
  constructor(client) {
    super(client)
    this.headPose = createPose()
    this.lTargetPose = createPose()
    this.rTargetPose = createPose()
    this.lGripPose = createPose()
    this.rGripPose = createPose()
    this.lGrip = createButton()
    this.rGrip = createButton()
    this.lTrigger = createButton()
    this.rTrigger = createButton()
    this.lBtn1 = createButton()
    this.rBtn1 = createButton()
    this.lBtn2 = createButton()
    this.rBtn2 = createButton()
  }

  init() {
    this.client.on('xrSession', this.onXRSession)
  }

  onXRSession = session => {
    this.session = session
  }

  preFixedUpdate() {
    if (this.session) {
      const frame = this.client.graphics.renderer.xr.getFrame()
      const refSpace = this.client.graphics.renderer.xr.getReferenceSpace()
      const head = frame.getViewerPose(refSpace)
      const pose = this.headPose
      pose.position.copy(head.transform.position)
      pose.quaternion.copy(head.transform.orientation)
      const inputSources = this.session.inputSources
      for (let i = 0; i < inputSources.length; i++) {
        const src = inputSources[i]
        if (src.handedness === Hands.LEFT) {
          // lTargetPose
          if (src.targetRaySpace) {
            const target = frame.getPose(src.targetRaySpace, refSpace)
            if (target) {
              const pose = this.lTargetPose
              pose.position.copy(target.transform.position)
              pose.quaternion.copy(target.transform.orientation)
            }
          }
          // lGripPose
          if (src.gripSpace) {
            const grip = frame.getPose(src.gripSpace, refSpace)
            if (grip) {
              const pose = this.lGripPose
              pose.position.copy(grip.transform.position)
              pose.quaternion.copy(grip.transform.orientation)
            }
          }
          if (src.gamepad) {
            // lTrigger
            {
              const button = this.lTrigger
              const down = src.gamepad.buttons[0].pressed
              if (down && !button.down) {
                button.pressed = true
                button.onPress?.()
              }
              if (!down && button.down) {
                button.released = true
                button.onRelease?.()
              }
              button.down = down
              button.value = src.gamepad.buttons[0].value
            }
            // lGrip
            {
              const button = this.lGrip
              const down = src.gamepad.buttons[1].pressed
              if (down && !button.down) {
                button.pressed = true
                button.onPress?.()
              }
              if (!down && button.down) {
                button.released = true
                button.onRelease?.()
              }
              button.down = down
              button.value = src.gamepad.buttons[1].value
            }
            // lBtn1
            {
              const button = this.lBtn1
              const down = src.gamepad.buttons[4].pressed
              if (down && !button.down) {
                button.pressed = true
                button.onPress?.()
              }
              if (!down && button.down) {
                button.released = true
                button.onRelease?.()
              }
              button.down = down
            }
            // lBtn2
            {
              const button = this.lBtn2
              const down = src.gamepad.buttons[5].pressed
              if (down && !button.down) {
                button.pressed = true
                button.onPress?.()
              }
              if (!down && button.down) {
                button.released = true
                button.onRelease?.()
              }
              button.down = down
            }
          }
        }
        if (src.handedness === Hands.RIGHT) {
          // rTargetPose
          if (src.targetRaySpace) {
            const target = frame.getPose(src.targetRaySpace, refSpace)
            if (target) {
              const pose = this.rTargetPose
              pose.position.copy(target.transform.position)
              pose.quaternion.copy(target.transform.orientation)
            }
          }
          // rGripPose
          if (src.gripSpace) {
            const grip = frame.getPose(src.gripSpace, refSpace)
            if (grip) {
              const pose = this.rGripPose
              pose.position.copy(grip.transform.position)
              pose.quaternion.copy(grip.transform.orientation)
            }
          }
          if (src.gamepad) {
            // rTrigger
            {
              const button = this.rTrigger
              const down = src.gamepad.buttons[0].pressed
              if (down && !button.down) {
                button.pressed = true
                button.onPress?.()
              }
              if (!down && button.down) {
                button.released = true
                button.onRelease?.()
              }
              button.down = down
              button.value = src.gamepad.buttons[0].value
            }
            // rGrip
            {
              const button = this.rGrip
              const down = src.gamepad.buttons[1].pressed
              if (down && !button.down) {
                button.pressed = true
                button.onPress?.()
              }
              if (!down && button.down) {
                button.released = true
                button.onRelease?.()
              }
              button.down = down
              button.value = src.gamepad.buttons[1].value
            }
            // rBtn1
            {
              const button = this.rBtn1
              const down = src.gamepad.buttons[4].pressed
              if (down && !button.down) {
                button.pressed = true
                button.onPress?.()
              }
              if (!down && button.down) {
                button.released = true
                button.onRelease?.()
              }
              button.down = down
            }
            // rBtn2
            {
              const button = this.rBtn2
              const down = src.gamepad.buttons[5].pressed
              if (down && !button.down) {
                button.pressed = true
                button.onPress?.()
              }
              if (!down && button.down) {
                button.released = true
                button.onRelease?.()
              }
              button.down = down
            }
          }
        }
      }
    }
  }

  postLateUpdate(delta) {
    // clear pressed buttons
    this.lGrip.pressed = false
    this.rGrip.pressed = false
    this.lTrigger.pressed = false
    this.rTrigger.pressed = false
    this.lBtn1.pressed = false
    this.rBtn1.pressed = false
    this.lBtn2.pressed = false
    this.rBtn2.pressed = false
    // clear released buttons
    this.lGrip.released = false
    this.rGrip.released = false
    this.lTrigger.released = false
    this.rTrigger.released = false
    this.lBtn1.released = false
    this.rBtn1.released = false
    this.lBtn2.released = false
    this.rBtn2.released = false
  }

  vibrate(hand, intensity = 0.5, duration = 100) {
    if (!this.session) return
    const inputSources = this.session.inputSources
    for (let i = 0; i < inputSources.length; i++) {
      const src = inputSources[i]
      if (src.handedness === hand) {
        // check if gamepad has haptic actuators
        if (src.gamepad && src.gamepad.hapticActuators) {
          const actuator = src.gamepad.hapticActuators[0]
          // Trigger the haptic pulse
          if (actuator && actuator.pulse) {
            actuator.pulse(intensity, duration).catch(err => {
              console.warn('Haptic pulse failed:', err)
            })
          }
        }
        // otherwise try newer Gamepad API if available
        if (src.gamepad && 'vibrationActuator' in src.gamepad) {
          const actuator = src.gamepad.vibrationActuator
          if (actuator && actuator.playEffect) {
            actuator
              .playEffect('dual-rumble', {
                startDelay: 0,
                duration: duration,
                weakMagnitude: intensity,
                strongMagnitude: intensity,
              })
              .catch(err => {
                console.warn('Vibration effect failed:', err)
              })
          }
        }
        break
      }
    }
  }
}

function createPose() {
  return {
    $pose: true,
    position: new THREE.Vector3(),
    quaternion: new THREE.Quaternion(),
  }
}

function createButton() {
  return {
    $button: true,
    down: false,
    pressed: false,
    released: false,
    value: 0, // eg xr triggers
    capture: false,
    onPress: null,
    onRelease: null,
  }
}
